import React from 'react'
import Modal from 'react-bootstrap/lib/Modal.js'
class ModalNotificacion extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render() {
        return (
            <Modal show={this.props.showModal} onHide={this.props.cancelModal}>
                <Modal.Header closeButton>
                    <Modal.Title>🎉 ¡Hoy estamos de cumpleaños!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.props.personas.length === 0 ? (
                        <p>No hay cumpleaños para mostrar.</p>
                    ) : (
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Rol</th>
                                    <th>Correo</th>
                                    <th>Teléfono</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.personas.map(persona => (
                                    <tr key={persona.id}>
                                        <td>{persona.nombre}</td>
                                        <td>{persona.rol}</td>
                                        <td>{persona.correo || '-'}</td>
                                        <td>{persona.telefono || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </Modal.Body>
            </Modal>
        )
    }
}
export default ModalNotificacion


// WEBPACK FOOTER //
// ./frontEnd/admin/Notificacion/components/Modal.jsx